import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=6a8b1432&scoped=true"
import script from "./Related.vue?vue&type=script&lang=js"
export * from "./Related.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=6a8b1432&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b1432",
  null
  
)

export default component.exports